import React from 'react'

export const InsuranceCarouselHeader = ({
  title,
  subTitle
}: {
  title?: string
  subTitle?: string
}) => {
  if (!title || !subTitle) {
    return null
  }

  return (
    <div className="flex w-full flex-wrap justify-between sm:flex-nowrap sm:items-center md:gap-x-8">
      <div className="h-fit max-w-full text-wrap pb-6 md:max-w-[680px]">
        <h2
          className={`pb-1 font-FieldsVariable text-lg font-medium text-gray-1100`}
        >
          {title}
        </h2>
        <span className="spacing-x-8 text-start font-normal text-gray-700">
          {subTitle}
        </span>
      </div>
    </div>
  )
}
